module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_szamlak9.db675765.jpg";